import { createAction } from "../creators";

export default {
  ...createAction("CONTACT_US", "payload"),
  ...createAction("CONTACT_US_COMPLETE", "data"),
};

 